/**
 * 买家进来主页的接口
 */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例
// import qs from 'qs'; // 根据需求是否导入qs模块

const admin = {
    //获取趋势的数据
    get_tendances(params) {
        return axios.get(`${base.dev}/v2/admin_config/get_tendances`, {params});
    },
    //更新趋势的数据
    update_tendances(params) {
        return axios.post(`${base.dev}/v2/admin_config/update_tendances`, params);
    },
    //获取系统配置
    get_config_system(params) {
        return axios.get(`${base.dev}/v2/admin_config/get_config_system`, {params});
    },
    //添加系统配置
    add_config_system(params) {
        return axios.post(`${base.dev}/v2/admin_config/add_config_system`, params);
    },
    //更新系统配置
    update_config_system(params) {
        return axios.post(`${base.dev}/v2/admin_config/update_config_system`, params);
    },
    //删除系统配置
    del_config_system(params) {
        return axios.post(`${base.dev}/v2/admin_config/del_config_system`, params);
    },
    //获取页面meta配置
    get_page_meta(params) {
        return axios.get(`${base.dev}/v2/admin_config/get_page_meta`, {params});
    },
    //添加页面meta配置
    add_page_meta(params) {
        return axios.post(`${base.dev}/v2/admin_config/add_page_meta`, params);
    },
    //更新页面meta配置
    update_page_meta(params) {
        return axios.post(`${base.dev}/v2/admin_config/update_page_meta`, params);
    },
    //删除页面meta配置
    del_page_meta(params) {
        return axios.post(`${base.dev}/v2/admin_config/del_page_meta`, params);
    },
    // 其他接口…………
}

export default admin;
